import { apiAxios, firebaseAuth } from 'src/constants';

export const refreshBigQueryDataUsecase = async () => {
  try {
    const request = await apiAxios.get('refreshBigQueryAnalytics', {
      headers: {
        Authorization: await firebaseAuth.currentUser?.getIdToken()
      }
    });
    if (request.status !== 200)
      return { error: new Error('Bad request'), data: null };

    return { error: null, data: request.data };
  } catch (e) {
    return { error: e, data: null };
  }
};
